export const availableLocales = [
	{
		name: 'Español',
		code: 'es-ES',
		file: 'es_ES',
		flag: 'es',
	},
	{
		name: 'Español (Latinoamérica)',
		code: 'es-MX',
		file: 'es_MX',
		flag: 'mx',
	},
	{
		name: 'English',
		code: 'en-GB',
		file: 'en',
		flag: 'gb',
	},
	{
		name: 'Italiano',
		code: 'it-IT',
		file: 'it',
		flag: 'it',
	},
	{
		name: 'Català',
		code: 'ca-ES',
		file: 'ca',
		flag: 'es-ca',
	},
	{
		name: 'Français',
		code: 'fr-FR',
		file: 'fr',
		flag: 'fr',
	},
	{
		name: 'Português',
		code: 'pt-PT',
		file: 'pt',
		flag: 'pt',
	},
	{
		name: 'Português (Brasil)',
		code: 'pt-BR',
		file: 'pt_BR',
		flag: 'br',
	},
	{
		name: 'Deutsch',
		code: 'de-DE',
		file: 'de',
		flag: 'de',
	},
	{
		name: 'Nederlands',
		code: 'nl-NL',
		file: 'nl',
		flag: 'nl',
	},
	// {
	//     name: 'Polski',
	//     code: 'pl-PL',
	//     file: 'pl',
	//     flag: 'pl',
	// },
];
